export const environment = {
    production: false,
    apiUrl: 'https://dev.cat-risk.com/api',
    gmap_key: 'AIzaSyDhnCkyEXNaRnHmm90R-pUGlAWtK7WnIZo',
    baseUrl: 'https://dev.cat-risk.com/',
    captcha_siteKey: '6LfZW_srAAAAACWG6dJsgos-954mPZokNfJu_aX9',
    frontendUrl: 'https://dev-yokahu-frontend.yokahu.co/',
    chatbotApiUrl: 'https://dev.cat-risk.com/chat-api'
};
	
